var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M400 200c0 110.28-89.721 200-200.004 200C89.713 400 0 310.28 0 200S89.713 0 199.996 0C310.279 0 400 89.72 400 200zm-26.232 0c0-95.816-77.955-173.769-173.772-173.769S26.23 104.183 26.23 200c0 95.817 77.95 173.77 173.766 173.77 95.816 0 173.772-77.954 173.772-173.77zm-82.818-65.475c5.125 5.12 5.125 13.426 0 18.546L178.581 265.439c-.013.013-.019.025-.027.035a13.083 13.083 0 0 1-9.279 3.842c-3.355 0-6.71-1.28-9.271-3.838l-50.963-50.954c-5.125-5.123-5.125-13.425 0-18.549 5.123-5.123 13.422-5.12 18.545-.003l41.689 41.68 103.131-103.126c5.117-5.124 13.422-5.124 18.544-.001z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon-check-circle.6cd79e99.svg";
export { ForwardRef as ReactComponent };